import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputProps, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { State, TemplateDto } from "../../interfaces";
import { getTemplates } from "../../store/actions";

type TProps = InputProps & {
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  value: any;
  onChange: (values: any) => void;
  placeholder: string;
};

export const TemplateSelect: React.FC<TProps> = ({
  onChange,
  value,
  closeMenuOnSelect = true,
  isMulti = false,
  placeholder,
}) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { loading, error, response, success } = useSelector(
    (state: any): State<TemplateDto[]> => state.template.templates
  );
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!loading && error)
      toast.error(error, {
        autoClose: 3000,
      });
  }, [loading]);

  const getData = () => {
    dispatch(getTemplates());
  };

  useEffect(() => {
    if (!loading && success) {
      var mappedOptions = response?.map((item: TemplateDto) => {
        return {
          label: item.friendlyName,
          value: item.sid,
        };
      });
      setOptions(mappedOptions);
    }
  }, [loading, i18n.language]);

  return (
    <>
      <p>
        <a
          href="https://console.twilio.com/us1/develop/sms/content-template-builder"
          target="_blank"
          rel="noreferrer"
          className="link"
          style={{ cursor: "pointer" }}
        >
          <i className="ri-link align-bottom me-1"></i>
          {t("manageTemplates")}
        </a>
      </p>
      <Label htmlFor="template" className="form-label">
        {t("template")}
        <span className="text-danger">*</span>
      </Label>
      <Select
        placeholder={t(placeholder)}
        closeMenuOnSelect={closeMenuOnSelect}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        options={options}
      />
    </>
  );
};
